/* eslint-disable */
<template>
  <div class="component-container" id="mygrid">
    <div
      v-if="!executeOnMount"
      v-bind:class="{
        'box-container-form': task.finished,
        'box-container': !task.finished,
      }"
    >
      <div class="content-container" id="area1">
        <!-- title header -->
        <div class="container-header">
          <p class="method-title">KONKORDANCJE</p>
          <router-link v-if="task.finished" :to="{ name: 'Concordance' }">
            <button
              class="box-close-btn"
              @click.prevent="task.finished = false"
            >
              {{ $t("cross") }}
            </button>
          </router-link>
          <router-link v-if="!task.finished" :to="{ name: 'Home' }">
            <button class="box-close-btn">{{ $t("cross") }}</button>
          </router-link>
        </div>

        <b-form
          class="concordance_form"
          @submit="startTask"
          v-if="!executeOnMount"
        >
          <b-form-group
            :label="this.$t('concordance.word')"
            label-for="extendedWordInput"
          >
            <b-form-input
              class="form-input-default"
              ref="extendedWordInput"
              type="text"
              :placeholder="this.$t('concordance.word_i')"
              required
              v-model="form.word"
              oninput="setCustomValidity('')"
            />
          </b-form-group>

          <b-form-group
            :label="this.$t('concordance.method')"
            label-for="methodInput"
          >
            <b-form-select
              class="form-input-select"
              selected=""
              id="methodInput"
              required
              v-model="method.selected"
              :options="method.options"
            />
          </b-form-group>

          <!-- Action Button -->
          <b-form-group class="filters">
            <input-tag
              v-show="metadata_filters.length > 0"
              v-model="filters_tagset"
              :delete-on-backspace="false"
              :read-only="true"
            ></input-tag>

            <b-button
              class="btn-block submit-button button-80"
              type="submit"
              v-if="!show.loading"
            >
              {{ $t("concordance.submit") }}
            </b-button>
            <b-button
              class="btn-block submit-button button-80"
              disabled
              v-if="show.loading"
            >
              <b-spinner small type="grow" /><span v-if="task.finished">{{
                $t("task.loading_data")
              }}</span
              ><span v-if="!task.finished">{{
                $t("task.waiting_for_response")
              }}</span>
            </b-button>
            <b-button
              class="filter-button button-20"
              @click="showFilters"
              v-show="!show.filters"
            >
              <i class="fas fa-filter"></i>
            </b-button>
            <b-button
              class="filter-button button-20"
              @click="hideFilters"
              v-show="show.filters"
            >
              <i class="fas fa-filter"></i>
            </b-button>
          </b-form-group>
          <b-form-group class="filters-grp">
            <TaskFilter
              :output="setFilters"
              v-show="show.filters"
              :visible="hideFilters"
              category="KONKORDANCJE"
            ></TaskFilter>
          </b-form-group>
          <b-form-group :label="this.$t('concordance.howmany')">
            <b-input-group
              :prepend="limit.toString()"
              class="mt-3"
              style="margin-bottom: 1rem"
            >
              <b-form-input
                type="range"
                min="10"
                max="100"
                step="5"
                v-model="limit"
                @change="changeLimit"
              />
            </b-input-group>
          </b-form-group>
        </b-form>
      </div>
    </div>
    <div
      class="text-center box-container-result"
      v-if="task.finished"
      id="area2"
    >
      <div class="content-container">
        <b-card class="bv-example-row">
          <div class="content-pagination">
            <span v-if="!show.loading" class="rows-count">{{
              countMessage
            }}</span>
            <vue-json-to-csv
              :json-data="json_data"
              :csv-title="csv_title"
              :separator="'\t'"
            >
              <b-button
                type="button"
                class="btn filter-button btn-secondary"
                style="float: right"
              >
                {{ $t("download_csv") }}
              </b-button>
            </vue-json-to-csv>
            <b-pagination
              :total-rows="concordances.length"
              @change="changePage"
              align="center"
              :per-page="limit"
              :current-page="page"
              v-model="page"
              v-if="concordances.length > 0"
            >
            </b-pagination>
          </div>
          <div class="spinner-container" v-if="show.loading">
            <b-spinner
              v-if="show.loading"
              style="width: 3rem; height: 3rem"
              class="spinner"
            />
          </div>
          <div class="content-list">
            <div
              class="justify-content-md-center"
              v-for="item in pages"
              :key="item.id"
            >
              <concordance-list
                :data="item"
                :document-request="getDocument"
              ></concordance-list>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal
      ref="documentModal"
      size="xl"
      :title="this.$t('concordance.modal_title')"
      :cancel-title="this.$t('concordance.modal_cancel')"
      cancel-variant="none"
      header-close-variant="light"
      ok-variant="none"
    >
      <div class="concordance-modal-body">
        <div class="concordance-properties">
          <div
            v-for="item in documentmodal.properties"
            :key="item.name"
            class="properties-group"
          >
            <div class="properties-name">{{ $t(item.name) }}:</div>
            <div class="properties-value">
              {{ item.value.replace(/-/g, ".") }}
            </div>
          </div>
        </div>
        <!-- TEXT AREA -->
        <div class="concordance-source-preview">
          <div class="tab-list">
            <button
              class="tab"
              id="sc-1"
              @click="show.word_cloud = true"
              :class="{ 'active-tab': show.word_cloud }"
            >
              Wordcloud
            </button>
            <button
              class="tab"
              id="sc-2"
              @click="show.word_cloud = false"
              :class="{ 'active-tab': !show.word_cloud }"
            >
              {{ $t("source") }}
            </button>
          </div>
          <b-row v-if="documentmodal.data.text && !show.word_cloud">
            <b-col style="text-align: justify; text-justify: inter-word">
              {{ documentmodal.data.text[0] }}
              <span style="color: #5fa0c8; font-weight: bold">
                {{ documentmodal.data.text[1] }}
              </span>
              <span style="color: #636363; font-weight: bold">
                {{ documentmodal.data.text[2] }}
              </span>
              <span style="color: #5fa0c8; font-weight: bold">
                {{ documentmodal.data.text[3] }}
              </span>
              {{ documentmodal.data.text[4] }}
            </b-col>
          </b-row>
          <div style="width: 100%; height: 100%">
            <wordcloud
              v-if="show.word_cloud"
              :data="word_cloud"
              nameKey="name"
              valueKey="value"
              :color="cat10"
              :showTooltip="false"
            >
            </wordcloud>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import VueAxios from "vue-axios";
import FadeTransition from "@/components/FadeTransition.vue";
import ConcordanceList from "@/components/ConcordanceList";
import TaskFilter from "@/components/TaskFilter";
import FilterDate from "@/components/FilterDate";
import VueJsonToCsv from "vue-json-to-csv";
import InputTag from "vue-input-tag";
import { i18n } from "../translations";
import wordcloud from "vue-wordcloud";

export default {
  name: "ConcordanceRequest",
  props: {
    executeOnMount: {},
    concordanceWord: {
      type: String,
    },
    publicationYear: {
      type: String,
    },
  },
  data() {
    return {
      json_data: [],
      csv_title: "concordance",
      form: {
        word: "",
        corpus: {
          selected: "chronopress",
          options: [{ value: "chronopress", text: "chronopress" }],
        },
      },
      task: {
        id: null,
        status: "",
        result: "",
        finished: false,
      },
      show: {
        loading: false,
        filters: false,
        word_cloud: true,
      },
      concordances: [],
      limit: 50,
      skip: 0,
      page: 1,
      documentmodal: {
        data: "",
        properties: [],
        show: false,
      },
      metadata_filters: [],
      word_cloud: [],
      cat10: [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf",
      ],
    };
  },
  components: {
    FilterDate,
    TaskFilter,
    ConcordanceList,
    axios,
    VueAxios,
    FadeTransition,
    VueJsonToCsv,
    InputTag,
    wordcloud,
  },
  watch: {
    page: function (value) {
      this.page = value;
      this.skip = this.limit * this.page;
    },
    limit: function (value) {
      this.limit = value;
      if (this.page > parseInt(this.concordances.length / this.limit) + 1) {
        this.page = parseInt(this.concordances.length / this.limit) + 1;
      }
      this.skip = this.limit * this.page;
    },
  },
  computed: {
    filters_tagset() {
      return this.metadata_filters.map(function (x) {
        return i18n.tc(x.name) + ":" + x.value;
      });
    },
    pages: function () {
      try {
        let concordances = this.concordances;
        let result = [];
        for (var i = this.skip - this.limit; i < this.skip; i++) {
          if (typeof concordances[i] !== "undefined") {
            result.push(concordances[i]);
          }
        }
        return result;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.error(Object.keys(e), e.message);
      }
    },
    method() {
      return {
        selected: "base",
        options: [
          { value: "base", text: this.$t("concordance.base") },
          { value: "orth", text: this.$t("concordance.orth") },
        ],
      };
    },
    countMessage() {
      let result = "";
      if (this.concordances.length === 0 || this.concordances.length > 5) {
        result = this.$t("concordance.found3");
      } else if (this.concordances.length === 1) {
        result = this.$t("concordance.found1");
      } else if (this.concordances.length > 1 && this.concordances.length < 5) {
        result = this.$t("concordance.found2");
      }
      return this.concordances.length + " " + result;
    },
  },
  methods: {
    showFilters: function () {
      this.show.filters = true;
    },
    hideFilters: function () {
      this.show.filters = false;
    },
    setFilters: function (metadata, all) {
      this.metadata_filters = [];
      for (let i = 0; i < all.length; i++) {
        if (
          typeof metadata[all[i]] !== "undefined" &&
          metadata[all[i]] !== ""
        ) {
          this.metadata_filters.push({
            name: all[i],
            value: metadata[all[i]],
          });
        }
      }
      if (
        typeof metadata["publication_year"] !== "undefined" &&
        metadata["publication_year"] !== ""
      ) {
        this.metadata_filters.push({
          name: "publication_year",
          value: metadata["publication_year"],
        });
      }
    },
    startTask: async function (event) {
      if (!this.executeOnMount) {
        event.preventDefault();
      }
      this.task.finished = false;
      this.show.loading = true;
      this.concordances = [];
      this.json_data = [];
      let task = {
        corpus: "chronopress",
        task_type: "concordance",
        metadata_filter: this.metadata_filters,
        query_parameters: [
          {
            name: this.method.selected,
            value: this.form.word,
          },
        ],
        response_parameters: ["journal_title", "publication_year"],
      };
      try {
        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          task,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            crossDomain: true,
            timeout: 5000,
          }
        );
        this.task.id = response.data.id;
        this.checkStatus(this.task.id, 100);
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.error(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId, timer) {
      try {
        timer += 100;
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          {
            timeout: 1000,
          }
        );
        this.task.status = response.data.status;
        if (this.task.status === "DONE") {
          this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          setTimeout(() => {
            this.checkStatus(taskId, timer);
          }, timer);
        }
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.error(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        this.task.finished = true;
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          {
            timeout: 5000,
          }
        );
        this.changePage(1);
        this.skip = this.limit;
        this.concordances = response.data.result.rows;
        this.csv_title =
          this.form.word + "_" + this.method.selected + "_" + this.task.id;
        this.show.loading = false;
        response.data.result.rows.forEach((x) => {
          const yearObject = x.properties.find(
            (item) => item.name === "publication_year"
          );
          const yearValue = yearObject ? yearObject.value : null;

          const titleObject = x.properties.find(
            (item) => item.name === "journal_title"
          );
          const titleValue = titleObject ? titleObject.value : null;

          this.json_data.push({
            left: x.concordances[0].left,
            word: x.concordances[0].word,
            right: x.concordances[0].right,
            title: titleValue,
            year: yearValue,
          });
        });
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.error(Object.keys(e), e.message);
        this.show.loading = false;
      }
    },
    changePage: function (value) {
      try {
        this.page = value;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.error(Object.keys(e), e.message);
      }
    },
    changeLimit: function (value) {
      try {
        this.changePage(1);
        this.limit = value;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.error(Object.keys(e), e.message);
      }
    },
    getDocument: function (request) {
      try {
        this.documentmodal.data = request.data.result.documents[0];
        this.documentmodal.properties = this.serializeProperties(
          request.data.result.documents[0].metadata.properties
        );
        this.word_cloud = JSON.parse(
          JSON.stringify(this.documentmodal.data.word_cloud)
        );

        setTimeout(() => {
          this.show.word_cloud = false;
        }, 100);
        setTimeout(() => {
          this.show.word_cloud = true;
        }, 200);
        this.$refs.documentModal.show();
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    serializeProperties: function (properties) {
      let time = { year: null, month: null, day: null };
      let result = [];
      properties.forEach(function (p) {
        if (p.name.split("_")[0] === "publication") {
          time[p.name.split("_")[1]] = p.value;
        } else if (
          p.name === "article_title" ||
          p.name === "journal_title" ||
          p.name === "authors"
        ) {
          p.value = p.value.charAt(0).toUpperCase() + p.value.slice(1);
          result.push({ name: p.name, value: p.value });
        } else {
          p.value = p.value.charAt(0).toLowerCase() + p.value.slice(1);
          result.push({ name: p.name, value: p.value });
        }
      });
      let newDate = new Date(time.year, time.month - 1, time.day);
      var dd = String(newDate.getDate()).padStart(2, "0");
      var mm = String(newDate.getMonth() + 1).padStart(2, "0");
      var yyyy = newDate.getFullYear();
      result.push({
        name: "publication_date",
        value: mm + "-" + dd + "-" + yyyy,
      });
      return result;
    },
    redirectUser: function (path) {
      this.$router.push(path);
    },
  },
  mounted() {
    try {
      if (
        this.executeOnMount === true &&
        typeof this.concordanceWord !== "undefined"
      ) {
        this.form.word = this.concordanceWord;
        if (typeof this.publicationYear !== "undefined") {
          let date = this.publicationYear.split("-");
          if (date.length > 1) {
            this.metadata_filters.push({
              name: "publication_year",
              value: date[1],
            });
            this.metadata_filters.push({
              name: "publication_month",
              value: date[0],
            });
          } else {
            this.metadata_filters.push({
              name: "publication_year",
              value: date[0],
            });
          }
        }
        this.startTask();
      }
    } catch (e) {
      this.$alert("", "Error while getting results", "warning");
      console.error(Object.keys(e), e.message);
    }
  },
};
</script>

<style scoped>
@media only screen and (max-width: 769px) {
  .box-container-form {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
@media only screen and (min-width: 768px) {
  .card-body {
    max-height: 75vh;
    min-height: 30vh;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 1rem;
  }
}
@media only screen and (max-width: 768px) {
  #mygrid {
    display: grid;
    grid-template-areas: "area1" "area2";
  }
  #area1 {
    grid-area: area1;
    position: relative;
    width: 100%;
    height: fit-content;
    min-height: 300px;
  }
  #area2 {
    z-index: 99;
    grid-area: area2;
    position: relative;
    width: 100%;
    padding-bottom: 1rem;
  }
  .box-container-form {
    height: fit-content;
  }
  #area2 .content-pagination {
    display: flex;
    flex-direction: column;
    height: fit-content;
  }
  .rows-count {
    margin-bottom: 0.2rem;
  }
  .filter-button {
    float: none !important;
  }
  #area2 .content-list {
    font-size: 12px;
  }
}
@media only screen and (max-width: 375px) {
  #mygrid {
    display: grid;
    grid-template-areas: "area1" "area2";
  }
  #area1 {
    grid-area: area1;
    position: relative;
    width: 100%;
    height: fit-content;
  }
  #area2 {
    z-index: 99;
    grid-area: area2;
    position: relative;
    top: 50%;
    width: 100%;
    height: 100%;
    padding-bottom: 1rem;
  }
  #area2 .content-pagination {
    display: flex;
    flex-direction: column;
    height: fit-content;
  }
  .rows-count {
    margin-bottom: 0.2rem;
  }
  .filter-button {
    float: none !important;
  }
  #area2 .content-list {
    font-size: 12px;
  }
}
#form_container {
  max-width: 40em;
  margin: 1vw auto;
  position: relative;
}
.component-container {
  background-color: transparent;
}
.box-container {
  border-radius: 0;
}
.container-header {
  display: flex;
  align-items: flex-start;
  background-color: var(--white_grey);
  align-items: center;
  border-radius: 5px;
  margin-bottom: 8px;
  padding-right: 4px;
}
.method-title {
  display: flex;
  width: 100%;
  font-weight: bold;
  color: var(--grey_black);
  margin: 6px;
  justify-content: center;
}
.box-close-btn {
  width: 25px;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
}
/* MODAL */
#modal {
  width: 80% !important;
}

.concordance-modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70vh;
}
.concordance-properties {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.5rem;
  padding-left: 0;
  width: 30%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  overflow-y: auto;
}
.properties-group {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-self: flex-start;
  align-items: flex-start;
  margin-bottom: 0.2rem;
  font-size: 1vw;
  width: 100%;
}
.geo-group {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 1px;
}
.geo-group-properties {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin-bottom: 0.2rem;
  margin-left: 0.5rem;
}
.properties-name {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  margin: 0;
  padding: 1px;
  background-color: rgb(241, 241, 241);
  font-weight: bold;
  width: 35%;
}
.properties-value {
  display: flex;
  align-self: center;
  justify-content: flex-start;
  align-content: center;
  align-items: flex-start;
  text-justify: inter-word;
  text-align: left;
  margin-left: 1rem;
  width: 60%;
}
.geo-names {
  color: white;
  background-color: rgb(61, 61, 61);
  width: 100%;
  padding: 0 0.31rem;
  margin-bottom: 0.2rem;
}
.concordance-source-preview {
  display: flex;
  flex-direction: column;
  width: 70%;
  height: 100%;
  background-color: rgb(238, 238, 238);
  overflow-y: auto;
  padding: 1.5rem;
  font-size: 0.95vw;

  font-family: "Courier New", Courier, monospace;
}
/* END MODAL */
.content-pagination {
  height: 50px;
  background-color: var(--dark_silver);
  padding: 6px;
}
.content-list {
  height: calc(100% - 50px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.box-container-result {
  overflow: inherit;
}
.rows-count {
  background-color: var(--grey_dark1);
  border-radius: 5px;
  float: left;
  padding: 8px 8px;
  color: white;
  height: 36px;
}
.filters-grp {
  z-index: 99;
  display: flex;
  width: auto;
  max-width: 500px;
  max-height: 30vh;
  padding-right: 1rem;
  overflow-y: scroll;
}
</style>
<style>
@media (min-width: 1200px) {
  .modal-xl {
    width: 80%;
    max-width: 2140px;
  }
}
.tab-list {
  display: inline-flex;
}
.tab {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 10rem;
  max-height: 2rem;
  margin-left: -1rem;
  padding-left: 2rem;
  padding-right: 1rem;
  border-radius: 0 15px 0 0;
  box-shadow: 5px -4px 5px rgba(0, 0, 0, 0.438);
  border: none;
  background-color: white;
}
.tab:hover {
  color: white;
  background-color: rgb(39, 39, 39);
}
.active-tab {
  background-color: rgb(238, 238, 238);
}
#sc-1 {
  z-index: 6;
  margin-bottom: 15px;
}
#sc-2 {
  z-index: 5;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConcordanceRequest.vue